export class Draft {
  constructor(data = {}) {
    this.id = data.id || '';
    this.status = data.status || 'draft';
    this.report_type = data.report_type || '';
    this.content = data.content || '';
    this.annex = data.annex || null;
    this.date_created = data.date_created ? new Date(data.date_created) : new Date();
    this.date_modified = data.date_modified ? new Date(data.date_modified) : new Date();
  }
}

export class CreateDraftDTO {
  constructor(data = {}) {
    this.report_type = data.report_type || '';
    this.content = data.content || '';
    this.annex = data.annex || null;
    this.status = data.status || 'draft';
  }
}

export class UpdateDraftDTO {
  constructor(data = {}) {
    if (data.report_type !== undefined) this.report_type = data.report_type;
    if (data.content !== undefined) this.content = data.content;
    if (data.annex !== undefined) this.annex = data.annex;
    if (data.status !== undefined) this.status = data.status;
  }
}

/**
 * AirplaneItem - Représente un item sauvegardé en mode avion
 * Peut être un audio ou un fichier OCR
 */
export class AirplaneItem {
  constructor(data = {}) {
    this.id = data.id || '';
    this.type = data.type || 'audio'; // 'audio' ou 'ocr'
    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date();

    // Audio specific
    this.durationSeconds = data.durationSeconds || 0;

    // OCR specific
    this.fileName = data.fileName || null;
    this.fileType = data.fileType || null;
    this.fileSize = data.fileSize || 0;

    // Common
    this.reportType = data.reportType || null;
  }

  /**
   * Formate la durée en mm:ss
   */
  getFormattedDuration() {
    if (this.type !== 'audio') return '';
    const mins = Math.floor(this.durationSeconds / 60);
    const secs = Math.floor(this.durationSeconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  /**
   * Formate la date/heure
   */
  getFormattedDate() {
    const date = this.createdAt instanceof Date ? this.createdAt : new Date(this.createdAt);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  /**
   * Retourne une description courte de l'item
   */
  getDescription() {
    if (this.type === 'audio') {
      return `Audio ${this.getFormattedDuration()}`;
    } else {
      return this.fileName || 'Fichier';
    }
  }
}